import React, { useState, useEffect, useRef } from 'react'
import { Label, Menu, Grid, Input, Button } from 'semantic-ui-react'
import { useSelector } from 'react-redux';
import _ from 'lodash'
import SearchLocation from '../../../components/SearchLocation/SearchLocation'
import { useTranslation } from 'react-i18next';
import "./SearchRealStates.css"
import SearchPropertyType from '../../../components/SearchPropertyType/SearchPropertyType';
import SearchPropertyListing from '../../../components/SearchPropertyListing/SearchPropertyListing';
import SearchPriceRangePicker from '../../../components/SearchPriceRangePicker/SearchPriceRangePicker';


function useOutsideAlerter(ref,setActiveItem) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setActiveItem("")
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}


const SearchRealStates = () => {
  const { t } = useTranslation()
  const [activeItem, setActiveItem] = useState('')
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setActiveItem);
  const minPrice = useSelector((state) => state.main.minPrice)
  const currencyRatio = useSelector((state) => state.main.currencyRatio)
  const maxPrice = useSelector((state) => state.main.maxPrice)
  



  const handleItemClick = (name) => {
    setActiveItem(name)
  }



  return <div ref={wrapperRef}><Grid textAlign="right" centered columns="equal" className="search-realstate m-1 bg-white rounded-50 text-black">
    <Grid.Row className="p-0 bg-f3 rounded-50">
      <Grid.Column verticalAlign="middle" onClick={() => handleItemClick('search-location')} className={`p-05 tabular-col ${activeItem === 'search-location' ? "tabular-col-active" : "tabular-col-notactive"}`}>
        <Menu.Item
          className="search-item"
          name={t("home:Location")}
          active={activeItem === 'search-location'}
        />

        <SearchLocation activeItem={activeItem} setActiveItem={setActiveItem}/>
      </Grid.Column>
      <Grid.Column verticalAlign="middle" onClick={() => handleItemClick('price-range')} className={`p-05 tabular-col ${activeItem === 'price-range' ? "tabular-col-active" : "tabular-col-notactive"}`}>
        <Menu.Item
          className="search-item"
          name={t("home:PriceRange")}
          active={activeItem === 'price-range'}
          
        />
        <div className="d-flex flex-row">
          <Input value={minPrice} className="w-30 price-input" />
          <Label className="d-flex align-items-center p-0 bg-transparent" >
            -
          </Label>
          <Input value={maxPrice} className="w-30 price-input" />
          <Label className="d-flex align-items-center rounded-50 white-nowrap p-0 bg-transparent" >
            {currencyRatio}
          </Label>
        </div>
        {
          activeItem === 'price-range' ? <SearchPriceRangePicker /> : null
        }
      </Grid.Column>
      <Grid.Column verticalAlign="middle" onClick={() => handleItemClick('property-type')} className={`p-05 tabular-col ${activeItem === 'property-type' ? "tabular-col-active" : "tabular-col-notactive"}`}>
        <Menu.Item
          className="search-item"
          name={t("home:PropertyType")}
          active={activeItem === 'property-type'}
          
        />
        <SearchPropertyType activeItem={activeItem} setActiveItem={setActiveItem}/>

      </Grid.Column>
      <Grid.Column verticalAlign="middle" onClick={() => handleItemClick('property-listing')} className={`p-05 tabular-col ${activeItem === 'property-listing' ? "tabular-col-active" : "tabular-col-notactive"}`}>
        <Menu.Item
          className="search-item"
          name={t("home:PropertyListing")}
          active={activeItem === 'property-listing'}
          
        />
        <SearchPropertyListing activeItem={activeItem} setActiveItem={setActiveItem}/>

      </Grid.Column>


      <Grid.Column width="1" verticalAlign="middle" className="p-0 text-center">

        <Button circular size='tiny' icon="search" color="red" >
        </Button>
      </Grid.Column>


    </Grid.Row>
  </Grid>
  </div>

}

export default SearchRealStates